import { useCallback, useEffect } from "react"
import { useSignal } from "@preact/signals-react"
import { officeModalData } from "@signals"


export default function useOfficeModalFilter() {
	const filteredList = useSignal([])
	const filteredOffices = useSignal("")
	const typesOptions = useSignal([])
	const countriesOptions = useSignal([])

	useEffect(() => {
		filteredList.value = officeModalData.value
	}, [officeModalData.value])

	const applyFilters = () => {
		const searchTerm = filteredOffices.value?.toLowerCase() || ''
		filteredList.value = officeModalData.value.filter(({ name, type, country }) => {
			const matchesSearchTerm = searchTerm ? name.toLowerCase().includes(searchTerm) : true
			const matchesType = typesOptions.value.length
				? typesOptions.value.some(option => type?.toLowerCase().includes(option.toLowerCase()))
				: true
			const matchesCountry = countriesOptions.value.length
				? countriesOptions.value.some(option => country?.toLowerCase().includes(option.toLowerCase()))
				: true
			return matchesSearchTerm && matchesType && matchesCountry
		})
	}

	const onChangeOffice = useCallback(e => {
		filteredOffices.value = e.target.value
	}, [])

	const onChangeType = useCallback(e => {
		typesOptions.value = e.target.value
	}, [])

	const onChangeCountry = useCallback(e => {
		countriesOptions.value = e.target.value
	}, [])

	return {
		filteredList: filteredList.value,
		filteredOffices: filteredOffices.value,
		countriesOptions: countriesOptions.value,
		typesOptions: typesOptions.value,
		applyFilters,
		onChangeOffice,
		onChangeType,
		onChangeCountry,
	}
}